import type { BetType } from '../../../store';

import type { ComputedBet } from './types';

export const getComputedBets = (betStack: BetType[]): ComputedBet[] => {
  const bet = betStack[betStack.length - 1];
  const computedBets: ComputedBet[] = [];
  if (bet) {
    Object.keys(bet.betSpots)
      .map(Number)
      .forEach((betId) => {
        const betValue = bet?.betSpots[betId]?.value;
        if (betValue) {
          computedBets.push({ betId, value: betValue });
        }
      });
  }
  return computedBets;
};
